// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2ieyO","header":"Messages_header__1hUvz"};